// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".completed-overlay[data-v-1d052bc0]{position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;z-index:100}", ""]);
// Exports
module.exports = exports;
